import { render, staticRenderFns } from "./tg_restaurants.vue?vue&type=template&id=7c6d7b99&scoped=true&"
import script from "./tg_restaurants.vue?vue&type=script&lang=js&"
export * from "./tg_restaurants.vue?vue&type=script&lang=js&"
import style0 from "./tg_restaurants.vue?vue&type=style&index=0&id=7c6d7b99&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "7c6d7b99",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/var/www/host/getorder/api/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('7c6d7b99')) {
      api.createRecord('7c6d7b99', component.options)
    } else {
      api.reload('7c6d7b99', component.options)
    }
    module.hot.accept("./tg_restaurants.vue?vue&type=template&id=7c6d7b99&scoped=true&", function () {
      api.rerender('7c6d7b99', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "resources/js/app/components/roles/row/tabs/tg/tg_restaurants.vue"
export default component.exports